module.exports = __webpack_public_path__ + "media/images/header_logo-b370308760f0d74ef5b104ab1f3d9de5.png";